import { useContext, useEffect, useState } from 'react';
import { getLabel } from '../../data/labels';
import Loader from '../../common/Loader';
import { useFetchCheckbetTicket } from '../../data/fetchCheckbetTicket';
import { formatDate } from '../../data/utils/formatDate';
import { getCheckbetUrl } from '../../data/utils/getCheckbetUrl';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencySymbol } from '../../data/utils/getCurrencySymbol';
import { getPrintableAmount } from '../../data/utils/getPrintableAmount';
import { TicketPrinterContext } from '../printer/TicketPrinterContext';
import EventsList from './EventsList';
import ReloadTicketButton from './ReloadTicketButton';
import SocialShareButtons from './SocialShareButtons';
import TupleInfo from './TupleInfo';
import Winnings from './Winnings';
import { getEnv } from '../env';
import ToggleNotifications from './my-bets-layout-3/ToggleNotifications';
import ExternalDetailsLink from './ExternalDetailsLink';

function SystemBetsTicket(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
    const printerContext = useContext(TicketPrinterContext);
    const ticketUrl = getCheckbetUrl(props.ticket.id);
    const printTicketEnabled = conf.pto !== undefined? conf.pto : true;
    
    const [state, setState] = useState({
        data: null,
        eventsToggled: false,
        tuplesInfoToggled: false,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setData(data) {
            this.update({data});
        },
        toggleEvents() {
            this.update({eventsToggled: !this.eventsToggled});
        },
        toggleTuplesInfo() {
            this.update({tuplesInfoToggled: !this.tuplesInfoToggled});
        },
        reset() {
            this.update({data: null, eventsToggled: false, tuplesInfoToggled: false});
        }
    });

    const [request, dispatch] = useFetchCheckbetTicket(props.ticket.id, state.eventsToggled || state.tuplesInfoToggled, props.ticket.isLive, false, true);

    useEffect(() => {
        if (request.data != null && !request.isError) {
            state.setData(request.data);
        }
    }, [request.data, request.isError]);

    useEffect(() => {
        if (state.data != null && !props.toggled) {
            state.reset();
        }
    }, [props.toggled]);

    function toggleEvents() {
        state.toggleEvents();
        if (!state.tuplesInfoToggled) {
            props.toggleTicket(props.ticket.id);
        }
    }

    function toggleTuplesInfo() {
        state.toggleTuplesInfo();
        if (!state.eventsToggled) {
            props.toggleTicket(props.ticket.id);
        }
    }

    const showEvents = props.toggled && state.eventsToggled;
    const showTuplesInfo = props.toggled && state.tuplesInfoToggled;

    return (
        <div className="mybet-container d-flex flex-column">
            <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle" onClick={toggleEvents}>
                <span className="text-big">{getLabel('mybets.sistema')} ({props.ticket.eventsCount})</span>
                <span className="margin-auto">
                    {props.ticket.funBonus &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.funbonus"')}</span>
                    }
                    {props.ticket.freeBet &&
                        <span className="cg-mybet-funbonus">{getLabel('mybets.freebet"')}</span>
                    }
                </span>
                <ExternalDetailsLink ticketId={props.ticket.id} />
                <span>{getLabel('mybets.dettagli')} <span onClick={toggleEvents}>{showEvents ? '-' : '+'}</span></span>
            </div>
            <hr />
            {showEvents &&
                (state.data == null ?
                    <Loader error={request.isError} />
                    :
                    <div className="mybet-events-container" >
                     {conf.pnc?.enabled && <ToggleNotifications state={state} dispatch={dispatch} />}
                        <EventsList events={state.data.events} isSystem={true} />
                    </div>
                )
            }
            <div className="light-grey-bg">
                <div className="bet-info d-flex justify-content-space-between align-items-center">
                    <div className="d-flex flex-column text-small">
                        <span className="grey">{getLabel('mybets.quotatotale')}</span><span className="text-medium bold">{getLabel('mybets.nondisponibile')}</span>
                    </div>
                    <div className="d-flex flex-column text-small">
                        <span className="grey">{getLabel('mybets.importo')}</span><span className="text-medium bold">{getPrintableAmount(props.ticket.amount, conf.cs.m, conf.cs.nd)} {currency}</span>
                    </div>
                    <Winnings {...props.ticket} />
                </div>
                <hr />
                <div className="bet-info d-flex justify-content-space-between align-items-center">
		    		<div className="d-flex flex-column text-small var-disclaimer">
	    				<span className="bet-info-buttons-container justified-text text-medium bold">
                            {printTicketEnabled && 
                                <div className="my-bets-printer" onClick={() => { printerContext.printTicket(props.ticket.id, false)}}>
                                    <img src={`${getEnv('PUBLIC_URL')}/assets/images/print.svg`} alt="Print button" />
                                </div>
                            }
	    					<SocialShareButtons ticketUrl={ticketUrl} />
                            <ReloadTicketButton id={props.ticket.id} />
	    				</span>
		    		</div>
		    		 {/*
		    			<button onClick={() => { openCashout()}} className="bottone bet-info bg-arancio bianco maiuscolo">
		    				{getLabel('checkbet.button')}
		    				<span className="checkbetIconContainer">
		    				<i className="fa fa-caret-right"></i>
		    				</span>
		    			</button>	
		    		 */}
	    		</div>
	    		<hr />
                <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey pointer tuples-toggle" onClick={toggleTuplesInfo}>
                    <div className="d-flex justify-content-space-between">
                        <span>{getLabel('mybets.sistema')}</span>
                        &nbsp;
                        <span>({getLabel('mybets.dettagli')} <span onClick={toggleEvents}>{showTuplesInfo ? '-' : '+'}</span>)</span>
                    </div>
                    <div className="d-flex justify-content-space-between">
                        <span>Ref. {props.ticket.id}</span>
                        <span className="margin-left-right">|</span>
                        <span>{formatDate(props.ticket.timestamp).formatted}</span>
                    </div>
                </div>
            </div>
            {showTuplesInfo &&
                (state.data == null ?
                    <Loader error={request.isError} />
                    :
                    <div className="light-grey-bg">
                        <TupleInfo tuples={state.data.tuples} ticketId={props.ticket.id}  />
                    </div>
                )
            }
        </div>
    );
}

export default SystemBetsTicket;